import React from 'react';

interface AccountSectionTitleProps {
  text: string;
  description?: string;
  customClass?: string;
}

const AccountSectionTitle: React.FC<AccountSectionTitleProps> = ({ text, description, customClass }) => {
  if (!text) return null;

  return (
    <div>
      <div
        className={`font-sohne pt-0 text-lg leading-6 font-normal text-black md:text-[26px] md:leading-8 ${customClass || ''}`}
      >
        {text}
      </div>
      {description && <div className="font-sohne mt-1 text-base leading-[22px] font-normal">{description}</div>}
    </div>
  );
};

export default AccountSectionTitle;
